import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getUserLicenses } from "../../services/auth/userDetails";
import "./UserLicenses.css";

const normalizeLicenseName = (value) => String(value || "-").replace(/_/g, " ");

const buildLoadingTiles = (count = 4) => Array.from({ length: count }, (_, index) => index);

const UserLicenses = () => {
    const [licenses, setLicenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let isMounted = true;

        const loadLicenses = async () => {
            try {
                const response = await getUserLicenses();
                const items = response?.data?.licenses || response?.data?.data?.licenses || [];

                if (isMounted) {
                    setLicenses(Array.isArray(items) ? items : []);
                }
            } catch (err) {
                if (isMounted) {
                    setError("Unable to load user licenses right now.");
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        loadLicenses();

        return () => {
            isMounted = false;
        };
    }, []);

    const licenseTiles = licenses.map((license) => ({
        ...license,
        displayName: normalizeLicenseName(license?.skuPartNumber),
    }));

    return (
        <section className="user-licenses-page">
            <div className="user-licenses-hero">
                <div className="container">
                    <h1 className="user-licenses-title">My Licenses</h1>
                    <div className="user-licenses-breadcrumb">
                        <Link to="/" className="user-licenses-breadcrumb-link">
                            Home
                        </Link>
                        <span className="user-licenses-breadcrumb-separator">/</span>
                        <span>My Licenses</span>
                    </div>
                    <p className="user-licenses-subtitle">
                        View the Microsoft licenses assigned to your account.
                    </p>
                </div>
            </div>

            <div className="user-licenses-content container">
                {error ? <div className="user-licenses-alert">{error}</div> : null}

                {loading ? (
                    <div className="user-licenses-grid" aria-busy="true" aria-live="polite">
                        {buildLoadingTiles().map((tileIndex) => (
                            <div
                                key={`license-loading-${tileIndex}`}
                                className="license-card license-card-loading"
                                style={{ animationDelay: `${tileIndex * 90}ms` }}
                            >
                                <div className="license-shimmer license-shimmer-pill" />
                                <div className="license-shimmer license-shimmer-line" />
                            </div>
                        ))}
                    </div>
                ) : licenseTiles.length > 0 ? (
                    <div className="user-licenses-grid" aria-live="polite">
                        {licenseTiles.map((license, index) => (
                            <article
                                key={license.id || license.skuId || license.skuPartNumber || index}
                                className="license-card"
                                style={{ animationDelay: `${index * 70}ms` }}
                            >
                                <div className="license-card-top">
                                    <span className="license-badge">Assigned</span>
                                </div>

                                <h2 className="license-name">{license.displayName}</h2>
                            </article>
                        ))}
                    </div>
                ) : (
                    <div className="user-licenses-empty">
                        <h2>No licenses found</h2>
                        <p>Your account does not currently have any assigned licenses.</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default UserLicenses;